import Vue from "vue";
import httpRequest from "@/utils/http";

Vue.prototype.$http = httpRequest;
